import { Switch, Space, Typography } from 'antd';

export function PeriodComparisonToggle({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <Space>
      <Typography.Text type="secondary">
        Compare to previous period
      </Typography.Text>
      <Switch checked={value} onChange={onChange} />
    </Space>
  );
}
